import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer: true,
    apiUrl: process.env.VUE_APP_API_URL,
    pageTitle: '',
    token: '',
    user: {},
    users: null,
    cities:  null ,
    products: null,
    snackbar: { value: false, text: ''}

  },
  mutations: {
    mutate(state, payload) {
      state[payload.prop] = payload.data;
    },
  },
  actions: {
  },
  modules: {
  }
})
